module.exports = __webpack_public_path__ + "static/media/ve2ventures.b65bb92f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/ve2ventures.webp
// module id = 440
// module chunks = 0